import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function Legal() {
  return (
    <main data-testid="legal-page" style={{ fontFamily: "Manrope, sans-serif" }}>
      <section className="pt-32 pb-8 px-5 lg:px-8" style={{ background: "#F8FAFC" }}>
        <div className="max-w-3xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <div className="section-label mb-4">Legal</div>
            <h1 style={{ fontFamily: "Playfair Display, serif", color: "#0D3A4F" }} className="text-4xl md:text-5xl font-bold mb-3">
              Aviso Legal y Privacidad
            </h1>
          </motion.div>
        </div>
      </section>

      <section className="py-12 pb-32 px-5 lg:px-8" style={{ background: "#FFFFFF" }}>
        <div className="max-w-3xl mx-auto prose prose-slate max-w-none">
          <div className="space-y-10 text-slate-600 text-sm leading-relaxed">
            <div>
              <h2 style={{ fontFamily: "Playfair Display, serif", color: "#0D3A4F" }} className="text-2xl font-semibold mb-4">
                1. Información general
              </h2>
              <p>
                En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico, se informa que el responsable de este sitio web es Campamento DAC-PAC.
              </p>
              <p className="mt-3">
                <strong>Email de contacto:</strong>{" "}
                <a href="mailto:info@dacpac.es" className="text-[#1B5F7E] hover:underline">
                  info@dacpac.es
                </a>
              </p>
            </div>

            <div>
              <h2 style={{ fontFamily: "Playfair Display, serif", color: "#0D3A4F" }} className="text-2xl font-semibold mb-4">
                2. Política de privacidad
              </h2>
              <p>
                En DAC-PAC tratamos los datos personales que nos facilitas a través de los formularios de esta web exclusivamente para:
              </p>
              <ul className="mt-3 space-y-2 ml-5 list-disc">
                <li>Gestionar solicitudes de información y preinscripción</li>
                <li>Enviarte información sobre nuestras actividades cuando nos lo has solicitado</li>
                <li>Responder a tus consultas de contacto</li>
              </ul>
              <p className="mt-4">
                No cedemos ni vendemos tus datos a terceros. Los datos se conservan durante el tiempo necesario para atender tu solicitud y, en todo caso, durante el tiempo legalmente exigido.
              </p>
            </div>

            <div>
              <h2 style={{ fontFamily: "Playfair Display, serif", color: "#0D3A4F" }} className="text-2xl font-semibold mb-4">
                3. Derechos del usuario
              </h2>
              <p>
                Puedes ejercer en cualquier momento tus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad de los datos enviando un correo a{" "}
                <a href="mailto:info@dacpac.es" className="text-[#1B5F7E] hover:underline">
                  info@dacpac.es
                </a>
                .
              </p>
            </div>

            <div>
              <h2 style={{ fontFamily: "Playfair Display, serif", color: "#0D3A4F" }} className="text-2xl font-semibold mb-4">
                4. Política de cookies
              </h2>
              <p>
                Este sitio web utiliza cookies técnicas necesarias para su funcionamiento. No utilizamos cookies publicitarias ni de seguimiento de terceros.
              </p>
              <p className="mt-3">
                Puedes configurar tu navegador para rechazar o eliminar las cookies. Ten en cuenta que algunas funcionalidades del sitio pueden verse afectadas.
              </p>
            </div>

            <div>
              <h2 style={{ fontFamily: "Playfair Display, serif", color: "#0D3A4F" }} className="text-2xl font-semibold mb-4">
                5. Propiedad intelectual
              </h2>
              <p>
                Todos los contenidos de este sitio web (textos, imágenes, logotipos, diseño) son propiedad de Campamento DAC-PAC o se utilizan bajo licencia. Queda prohibida su reproducción total o parcial sin autorización expresa.
              </p>
            </div>

            <div className="pt-4 border-t border-slate-100">
              <p className="text-xs text-slate-400">
                Última actualización: Marzo 2026
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
